import * as React from 'react';
import PresentationDayModel from './PresentationDayModel';
import PresentationDay from './PresentationDay';

const PresentationDays = ({ days }: { days: Array<PresentationDayModel> }) => <>
    {days.map((day) => <PresentationDay day={day} />)}
</>;

export default PresentationDays;
